import React, { Fragment } from 'react';

import useNationalTeamMissedDrugTests from './UseNationalTeamMissedDrugTests';

import NationalTeamMissedDrugTestsGrid from './NationalTeamMissedDrugTestsGrid';

import Headings from '@usas/ui-web/components/headings/Headings';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';

const NationalTeamMissedDrugTests = () => {
  const {
    title,
    DEFAULT_ID,
    personNationalTeamState,
    onAddEditMissedDrugTests
  } = useNationalTeamMissedDrugTests();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>{title}</Headings.H3>
        </div>
      </div>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <ActionIntraPageButton onClick={(e) => onAddEditMissedDrugTests(e, DEFAULT_ID)}>Add Missing Drug Test</ActionIntraPageButton>
        </div>
      </div>
      <div className="row usas-extra-top-margin usas-extra-bottom-margin">
        <div className="col-xs-12">
          <NationalTeamMissedDrugTestsGrid gridState={personNationalTeamState} onAddEdit={onAddEditMissedDrugTests} />
        </div>
      </div>
    </Fragment>
  );
}

export default NationalTeamMissedDrugTests;